import { useScreenMessage } from '@gogame/screens';

import { uploadFile } from 'scenes/FinancialResults/sources/financialResults';

export const useUploadInvoice = () => {
  const { showSuccessMessage, showErrorMessage } = useScreenMessage();

  return async (file) => {
    try {
      const response = await uploadFile(file);
      showSuccessMessage('Invoices was uploaded.');
      return response;
    } catch (e) {
      showErrorMessage(e.message);
      return Promise.reject(e);
    }
  };
};
